/* eslint-disable react/prop-types */
import React from 'react'
import { withPrefix } from 'gatsby'
import { Helmet } from 'react-helmet'
import { Provider } from 'react-redux'
import createSagaMiddleware from 'redux-saga'

import { configureStore } from './configure-store'
import { rootSaga } from './sagas'

const sagaMiddleware = createSagaMiddleware()

const middlewares = [sagaMiddleware]

const store = configureStore({}, middlewares)

sagaMiddleware.run(rootSaga)

export const wrapWithProvider = ({ element }) => (
  <Provider store={store}>
    <Helmet>
      <script type="text/javascript" src={withPrefix(`/env.js`)} />
    </Helmet>
    {element}
  </Provider>
)
